import firebase from 'firebase/app'
import 'firebase/database'
import config from '../services/firebaseConfig'

if (!firebase.apps.length) {
  firebase.initializeApp(config)
}

const groupMembersRef = firebase.database().ref('groupMembers')
const memberRequestsRef = firebase.database().ref('memberRequests')

const groupRepository = {
  /**
   * Get the group membership status of the given user in the given group
   * @param {string} groupId
   * @param {string} userId
   * @return {Promise<boolean?>}
   * true if the user is a group admin,
   * false if the user is just a group member,
   * null otherwise
   */
  async getGroupMembershipStatus (groupId, userId) {
    try {
      const membershipStatusSnapshot = await groupMembersRef.child(groupId).child(userId).once('value')
      return membershipStatusSnapshot.exists() ? membershipStatusSnapshot.val() : null
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * Get the member request status of the given user for the given group
   * @param {string} groupId
   * @param {string} userId
   * @return {Promise<number>}
   * The time (in milliseconds) if the user's request isn't accepted yet,
   * 0 if the user's request is rejected,
   * null otherwise
   */
  async getMemberRequestStatus (groupId, userId) {
    try {
      const memberRequestSnapshot = await memberRequestsRef.child(groupId).child(userId).once('value')
      return memberRequestSnapshot.val()
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * Saves the userId to member requests
   * @param {string} groupId
   * @param {string} userId
   */
  async saveUserToMemberRequests (groupId, userId) {
    try {
      await firebase.database().ref('memberRequests').child(groupId).child(userId).set(new Date().getTime())
      return true
    } catch (error) {
      console.log(error)
      return false
    }
  }
}

export default groupRepository



// WEBPACK FOOTER //
// ./src/repositories/GroupRepository.js